<template>
    <q-page class=" q-pa-lg ">
        <q-dialog v-model="dialogDetMov" maximized>
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">{{ $t('centroCostos.details.title') || 'Detalles' }}</div>
                    <q-space />
                    <q-btn icon="mdi-close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-table class="shadow-0 header-tabla" :columns="columnsDetPol" row-key="_id" :data="dataDetPol" :rows-per-page-options="[0]" :pagination.sync="pagination">
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td auto-width key="acciones">
                                    <q-btn size="md" color="red-6" rounded flat dense icon="mdi-file-document"
                                        @click="VerPolizas(props.row)">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">{{ $t('centroCostos.auxiliar.viewVoucher') || 'Ver Póliza' }}</q-tooltip>
                                    </q-btn>
                                    <q-btn size="md" color="red-6" rounded flat dense icon="mdi-format-list-bulleted"
                                        @click="VerFacturas(props.row)">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">{{ $t('centroCostos.incomeStatement.viewInvoice') || 'Ver Facturas' }}</q-tooltip>
                                    </q-btn>
                                </q-td>
                                <q-td key="numCuenta" :props="props">{{ props.row.numCuenta }}</q-td>
                                <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                                <q-td key="importeComprobantes" :props="props">{{ formatCurrency(props.row.importeComprobantes) }}</q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>
        <q-dialog v-model="dialogFacturas" maximized>
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">{{ $t('centroCostos.incomeStatement.viewInvoice') || 'Facturas' }}</div>
                    <q-space />
                    <q-btn icon="mdi-close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-table class="shadow-0 header-tabla" :columns="columnsFacturas" row-key="_id" :data="dataFacturas" :rows-per-page-options="[0]" :pagination.sync="pagination">
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td auto-width key="acciones">
                                    <q-btn size="md" color="red-6" rounded flat dense icon="mdi-file-pdf-box"
                                        @click="VerFacturaPdf(props.row)">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">{{ $t('centroCostos.incomeStatement.viewInvoice') || 'Ver Factura' }}</q-tooltip>
                                    </q-btn>
                                </q-td>
                                <q-td key="serie" :props="props">{{ props.row.serie }}</q-td>
                                <q-td key="folio" :props="props">{{ props.row.folio }}</q-td>
                                <q-td key="fecha" :props="props">{{ props.row.fecha }}</q-td>
                                <q-td key="rfc" :props="props">{{ props.row.rfc }}</q-td>
                                <q-td key="nombre" :props="props">{{ props.row.nombre }}</q-td>
                                <q-td key="tipoComprobante" :props="props">{{ props.row.tipoComprobante }}</q-td>
                                <q-td key="subTotal" :props="props">{{ formatCurrency(props.row.subTotal) }}</q-td>
                                <q-td key="total" :props="props">{{ formatCurrency(props.row.total) }}</q-td>
                                <q-td key="formaPago" :props="props">{{ props.row.formaPago }}</q-td>
                                <q-td key="metodoPago" :props="props">{{ props.row.metodoPago }}</q-td>
                                <q-td key="folioFiscal" :props="props">{{ props.row.folioFiscal }}</q-td>
                                <q-td key="moneda" :props="props">{{ props.row.moneda }}</q-td>
                                <q-td key="usoCfdi" :props="props">{{ props.row.usoCfdi }}</q-td>
                                <q-td key="fechaPago" :props="props">{{ props.row.fechaPago }}</q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>
        <q-dialog v-model="dialogPolizas" maximized>
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">{{ $t('home.polizas') || 'Pólizas' }}</div>
                    <q-space />
                    <q-btn icon="mdi-close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-table class="shadow-0 header-tabla" :columns="columnsPolizas" row-key="_id" :data="dataPolizas" :rows-per-page-options="[0]" :pagination.sync="pagination">
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td auto-width key="acciones">
                                    <q-btn size="md" color="red-6" rounded flat dense icon="mdi-file-pdf-box"
                                        @click="VerPolizaPdf(props.row)">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">{{ $t('centroCostos.auxiliar.viewVoucher') || 'Ver Póliza' }}</q-tooltip>
                                    </q-btn>
                                </q-td>
                                <q-td key="tipo" :props="props">{{ props.row.tipo }}</q-td>
                                <q-td key="numPoliza" :props="props">{{ props.row.numPoliza }}</q-td>
                                <q-td key="fecha" :props="props">{{ props.row.fecha }}</q-td>
                                <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogPDF" transition-show="scale" transition-hide="scale" maximized>
            <visor-pdf ref="miComponenteHijo" @CloseDialogPdf="CloseDialogPdf"></visor-pdf>
        </q-dialog>
        
        <div class="row q-col-gutter-sm q-mb-lg">
            <div class="col-12 col-md-5">
                <div class=" text-h5">{{ $t('centroCostos.incomeStatement.title') }}</div>
            </div>

            <div class="col-12 col-md-2">
                <q-input v-model="fehaIMasked" filled :label="$t('centroCostos.incomeStatement.initialDate')" class="q-mr-sm" name="event" outlined dense>
                    <template v-slot:before>
                        <q-icon name="event" color="primary" />
                    </template>
                    <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                        <q-date v-model="fechaI" @input="UltimoDiaMes">
                            <div class="row items-center justify-end">
                                <q-btn v-close-popup label="Ok" color="primary" flat />
                            </div>
                        </q-date>
                    </q-popup-proxy>
                </q-input>
            </div>


            <div class="col-12 col-md-2">
                <q-input v-model="fechaFMasked" filled :label="$t('centroCostos.incomeStatement.finalDate')" class="q-mr-sm" name="event" outlined dense>
                    <template v-slot:before>
                        <q-icon name="event" color="primary" />
                    </template>
                    <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                        <q-date v-model="fechaF">
                            <div class="row items-center justify-end">
                                <q-btn v-close-popup label="Ok" color="primary" flat />
                            </div>
                        </q-date>
                    </q-popup-proxy>

                </q-input>
            </div>
            <div class="col-12 col-md-3">
                <q-select v-model="selectCc"  :options="itemsCc" dense filled :label="$t('centroCostos.incomeStatement.costCenter')" option-label="descripcion">
                    <template v-slot:after>
                        <q-btn flat round color="primary" icon="mdi-magnify" @click="GetEstadoDeResultados">
                            <q-tooltip>
                                {{ $t('centroCostos.incomeStatement.search') }}
                            </q-tooltip>
                        </q-btn>
                        <q-btn flat round color="primary" icon="mdi-microsoft-excel" @click="ExportarExcelDos">
                            <q-tooltip>
                                {{ $t('centroCostos.incomeStatement.exportExcel') }}
                            </q-tooltip>
                        </q-btn>
                        <q-btn flat round color="primary" icon="mdi-file-pdf-box" @click="ExportarPdf">
                            <q-tooltip>
                                {{ $t('centroCostos.incomeStatement.generatePdf') }}
                            </q-tooltip>
                        </q-btn>
                    </template>
                    </q-select>
            </div>

        </div>
        <q-table class="shadow-0 header-tabla" :columns="columns" row-key="_id" :data="itemsEstadoDeResultados"
            hide-header hide-bottom :rows-per-page-options="[0]" :pagination.sync="pagination">
            <template v-slot:body="props">
                <q-tr :props="props">
                    <q-td auto-width key="acciones">
                        <q-btn size="md" color="red-6" rounded flat dense icon="mdi-dots-vertical" v-if="props.row.detalles"
                            @click="VerDetalles(props.row)">
                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                content-style="font-size: 14px">{{ $t('centroCostos.incomeStatement.details') }}</q-tooltip>
                        </q-btn>
                    </q-td>
                    <q-td key="signo" :props="props">
                        <b style="font-size:18px" v-if="props.row.signo === '='">{{ props.row.signo }}</b>
                        <span v-else>{{ props.row.signo }}</span>
                    </q-td>
                    <q-td key="descripcion" :props="props">
                        <b style="font-size:18px" v-if="props.row.signo === '='">{{ props.row.descripcion }}</b>
                        <span v-else>{{ props.row.descripcion }}</span>
                    </q-td>
                    <q-td key="importe" :props="props">
                        <b style="font-size:18px" v-if="props.row.signo === '='">{{ formatCurrency(props.row.importe)
                        }}</b>
                        <span v-else>{{ formatCurrency(props.row.importe) }}</span>
                    </q-td>
                </q-tr>
            </template>
        </q-table>
    </q-page>
</template>
<script>

import { format } from 'date-fns';
import { parse } from 'date-fns';
import { endOfMonth } from 'date-fns';
import { es } from 'date-fns/locale';
import moment from 'moment';
import axios from 'axios'
import { QSpinnerCube } from 'quasar';
import { EstadoResultadosPDF } from '../PDF/EstadoResultadosPDF.js'
import * as XLSX from 'xlsx';
import visorPdf from '../PDF/VisorPDF.vue';

export default {
    components: {visorPdf},
    data() {
        return {
            fechaI: new Date(),
            fechaF: new Date(),
            banderaBonificacion: true,
            banderaCierre: false,

            pagination: {
                rowsPerPage: 0
            },
            itemsEstadoDeResultados: [],
            itemsCc: [],
            selectCc: null,

            //DETALLE DE LA POLIZA
            dialogPDF: false,
            dialogDetMov: false,
            dataDetPol: [],
            dialogFacturas: false,
            dataFacturas: [],
            dialogPolizas: false,
            dataPolizas: [],
        }
    },
    computed: {
        token() {
            return this.$store.state.usuario;
        },

        empresa() {
            return this.$store.state.empresaStore;
        },

        fehaIMasked() {
            moment.locale('es-mx');
            return this.fechaI ? moment(this.fechaI).format('DD/MMMM/yyyy') : ''
        },

        fechaFMasked() {
            moment.locale('es-mx');
            return this.fechaF ? moment(this.fechaF).format('DD/MMMM/yyyy') : ''
        },

        columns() {
            return [
                { name: 'acciones', align: 'center', label: this.$t('centroCostos.incomeStatement.actions'), field: 'name' },
                { name: 'signo', align: 'center', label: this.$t('centroCostos.incomeStatement.sign'), field: 'signo', style: 'text-align: left;' },
                { name: 'descripcion', align: 'center', label: this.$t('centroCostos.incomeStatement.description'), field: 'descripcion', style: 'text-align: left;' },
                { name: 'importe', align: 'center', label: this.$t('centroCostos.incomeStatement.amount'), field: 'importe', style: 'text-align: right;' },
            ];
        },

        columnsDetPol() {
            return [
                { name: 'acciones', align: 'center', label: this.$t('centroCostos.incomeStatement.actions'), field: 'acciones' },
                { name: 'numCuenta', align: 'left', label: this.$t('reportes.libroDiario.accountNo') || 'Cuenta', field: 'numCuenta', style: 'text-align: left;' },
                { name: 'descripcion', align: 'left', label: this.$t('centroCostos.incomeStatement.description'), field: 'descripcion', style: 'text-align: left;' },
                { name: 'importe', align: 'right', label: this.$t('centroCostos.incomeStatement.amount'), field: 'importe', style: 'text-align: right;' },
                { name: 'importeComprobantes', align: 'right', label: 'Importe comprobantes', field: 'importeComprobantes', style: 'text-align: right;' },
            ];
        },

        columnsFacturas() {
            return [
                { name: 'acciones', align: 'center', label: this.$t('centroCostos.incomeStatement.actions'), field: 'acciones' },
                { name: 'serie', align: 'left', label: 'Serie', field: 'serie', style: 'text-align: left;' },
                { name: 'folio', align: 'left', label: 'Folio', field: 'folio', style: 'text-align: left;' },
                { name: 'fecha', align: 'left', label: 'Fecha', field: 'fecha', style: 'text-align: left;' },
                { name: 'rfc', align: 'left', label: 'RFC', field: 'rfc', style: 'text-align: left;' },
                { name: 'nombre', align: 'left', label: 'Nombre', field: 'nombre', style: 'text-align: left;' },
                { name: 'tipoComprobante', align: 'left', label: 'Tipo Comprobante', field: 'tipoComprobante', style: 'text-align: left;' },
                { name: 'subTotal', align: 'right', label: 'SubTotal', field: 'subTotal', style: 'text-align: right;' },
                { name: 'total', align: 'right', label: 'Total', field: 'total', style: 'text-align: right;' },
                { name: 'formaPago', align: 'left', label: 'Forma de Pago', field: 'formaPago', style: 'text-align: left;' },
                { name: 'metodoPago', align: 'left', label: 'Método de Pago', field: 'metodoPago', style: 'text-align: left;' },
                { name: 'folioFiscal', align: 'left', label: 'Folio Fiscal', field: 'folioFiscal', style: 'text-align: left;' },
                { name: 'moneda', align: 'left', label: 'Moneda', field: 'moneda', style: 'text-align: left;' },
                { name: 'usoCfdi', align: 'left', label: 'Uso de Cfdi', field: 'usoCfdi', style: 'text-align: left;' },
                { name: 'fechaPago', align: 'left', label: 'Fecha de Pago', field: 'fechaPago', style: 'text-align: left;' },
            ];
        },

        columnsPolizas() {
            return [
                { name: 'acciones', align: 'center', label: this.$t('centroCostos.incomeStatement.actions'), field: 'acciones' },
                { name: 'tipo', align: 'left', label: this.$t('actions.type') || 'Tipo', field: 'tipo', style: 'text-align: left;' },
                { name: 'numPoliza', align: 'left', label: this.$t('reportes.libroDiario.policyNo') || 'Num. Póliza', field: 'numPoliza', style: 'text-align: left;' },
                { name: 'fecha', align: 'left', label: 'Fecha', field: 'fecha', style: 'text-align: left;' },
                { name: 'importe', align: 'right', label: this.$t('centroCostos.incomeStatement.amount'), field: 'importe', style: 'text-align: right;' },
            ];
        }

    },
    created() {
        this.getCc()

    },
    methods: {

        FormatDate(value) {
            let fecha_a = value.replace('T', ' ');
            let fecha_b = fecha_a.replace('Z', '');
            const cadenaFechaConHora = fecha_b;
            const fecha = parse(cadenaFechaConHora, 'yyyy-MM-dd HH:mm:ss', new Date());
            const formato = "dd-MMMM-yyyy HH:mm:ss";
            const configuracionLocal = { locale: es };
            let resultado = format(fecha, formato, configuracionLocal);
            return resultado;
        },

        UltimoDiaMes() {
            let fechaI = this.fechaI;
            fechaI = fechaI.replaceAll('/', '-');
            const fecha = parse(fechaI, 'yyyy-MM-dd', new Date());
            const ultimoDiaDelMes = endOfMonth(fecha);
            this.fechaF = ultimoDiaDelMes;
        },

        formatCurrency(value) {
            if (value != '-') {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            } else {
                return '';
            }
        },

        async GetEstadoDeResultados() {
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: this.$t('reportes.estadoResultados.generating') || 'Generando Estado de Resultados...', messageColor: 'white' })
            try {
                this.itemsEstadoDeResultados = [];
                let fechaI = new Date(this.fechaI);
                let fechaF = new Date(this.fechaF);
                fechaI = format(fechaI, 'yyyy-MM-dd');
                fechaF = format(fechaF, 'yyyy-MM-dd');
                let response = await axios.get('CentrosCostos/GetEstadoResultadosAsync/erp_' + this.token.rfc + '/' + fechaI + '/' + fechaF + '/' + this.banderaBonificacion + '/' + this.banderaCierre+'/'+ this.selectCc._id);
                let respuesta = response.data;

                //CREAMOS LA ESTRUCTURA DE LA TABLA
                let salto = { signo: '', descripcion: '', importe: '-', detalles: null };

                //INGRESOS
                const ingresos = respuesta.filter(x => x.tipo === 'INGRESOS')
                const sumIngresos = ingresos.map(item => item.importe).reduce((prev, curr) => prev + curr, 0);
                const objIngresos = { signo: '+', descripcion: this.$t('reportes.estadoResultados.netIncome'), importe: sumIngresos, detalles: ingresos }
                this.itemsEstadoDeResultados.push(objIngresos);

                // COSTOS
                const costos = respuesta.filter(x => x.tipo === 'COSTOS')
                const sumCosto = costos.map(item => item.importe).reduce((prev, curr) => prev + curr, 0);
                const objCosto = { signo: '-', descripcion: this.$t('reportes.estadoResultados.costOfSales'), importe: sumCosto, detalles: costos }
                this.itemsEstadoDeResultados.push(objCosto);

                //UTILIDAD BRUTA
                const objUtilidadBruta = { signo: '=', descripcion: this.$t('reportes.estadoResultados.grossProfit'), importe: sumIngresos - sumCosto, detalles: null }
                this.itemsEstadoDeResultados.push(objUtilidadBruta);
                this.itemsEstadoDeResultados.push(salto);

                //GASTOS GENERALES
                const gastos = respuesta.filter(x => x.tipo === 'GASTOS')
                const sumGastosGenerales = gastos.map(item => item.importe).reduce((prev, curr) => prev + curr, 0);
                const objGastosGenerales = { signo: '-', descripcion: this.$t('reportes.estadoResultados.generalExpenses'), importe: sumGastosGenerales, detalles: gastos }
                this.itemsEstadoDeResultados.push(objGastosGenerales);

                //UTILIDAD DE OPERACION
                const objUtilidadDeOperacion = { signo: '=', descripcion: this.$t('reportes.estadoResultados.operatingProfit'), importe: objUtilidadBruta.importe - sumGastosGenerales, detalles: null }
                this.itemsEstadoDeResultados.push(objUtilidadDeOperacion);
                this.itemsEstadoDeResultados.push(salto);

                //RESULTADO INTEGRAL DE FINANCIAMIENTO
                const resultado = respuesta.filter(x => x.tipo === 'RESULTADO')
                const sumResultadoIntegral = resultado.map(item => item.importe).reduce((prev, curr) => prev + curr, 0);
                const objResultadoIntegral = { signo: '-', descripcion: this.$t('reportes.estadoResultados.financingResult'), importe: sumResultadoIntegral, detalles: resultado }
                this.itemsEstadoDeResultados.push(objResultadoIntegral);

                //PARTICIPACIONES
                const participaciones = respuesta.filter(x => x.tipo === 'PARTICIPACIONES')
                const sumParticipaciones = participaciones.map(item => item.importe).reduce((prev, curr) => prev + curr, 0);
                const objParticipaciones = { signo: '+', descripcion: this.$t('reportes.estadoResultados.participation'), importe: sumParticipaciones, detalles: participaciones }
                this.itemsEstadoDeResultados.push(objParticipaciones);

                //UTILIDAD ANTES DE IMPUESTOS A LA UTILIDAD
                const objUtilidadImpuestos = { signo: '=', descripcion: this.$t('reportes.estadoResultados.profitBeforeTax'), importe: objUtilidadDeOperacion.importe - sumResultadoIntegral + sumParticipaciones, detalles: null }
                this.itemsEstadoDeResultados.push(objUtilidadImpuestos);
                this.itemsEstadoDeResultados.push(salto);

                //IMPUESTOS A LA UTILIDAD
                const Impuestos = respuesta.filter(x => x.tipo === 'IMPUESTOS')
                const sumImpuestos = Impuestos.map(item => item.importe).reduce((prev, curr) => prev + curr, 0);
                const objImpuestos = { signo: '-', descripcion: this.$t('reportes.estadoResultados.incomeTaxes'), importe: sumImpuestos, detalles: Impuestos }
                this.itemsEstadoDeResultados.push(objImpuestos);

                //UTILIDAD DE OPERACIONES CONTINUAS
                const objUtilidadOperaciones = { signo: '=', descripcion: this.$t('reportes.estadoResultados.continuousOperationsProfit'), importe: objUtilidadImpuestos.importe - sumImpuestos, detalles: null }
                this.itemsEstadoDeResultados.push(objUtilidadOperaciones);
                this.itemsEstadoDeResultados.push(salto);

                //OPERACIONES DISCONTINUADAS
                const operaciones = respuesta.filter(x => x.tipo === 'OPERACIONES')
                const sumDiscontinuadas = operaciones.map(item => item.importe).reduce((prev, curr) => prev + curr, 0);
                const objDiscontinuadas = { signo: '-', descripcion: 'Operaciones discontinuadas', importe: sumDiscontinuadas, detalles: operaciones }
                this.itemsEstadoDeResultados.push(objDiscontinuadas);

                //UTILIDAD DE OPERACIONES CONTINUAS (NETA)
                let desc_ = this.$t('reportes.estadoResultados.netProfit')
                if (objUtilidadOperaciones.importe - sumDiscontinuadas < 0) {
                    desc_ = this.$t('reportes.estadoResultados.loss')
                }
                const objUtilidadNeta = { signo: '=', descripcion: desc_, importe: objUtilidadOperaciones.importe - sumDiscontinuadas, detalles: null }
                this.itemsEstadoDeResultados.push(objUtilidadNeta);

                this.$q.loading.hide()
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
            }
        },

        async ExportarPdf() {
            if (this.itemsEstadoDeResultados.length == 0) {
                this.$q.notify({
                    type: 'warning',
                    message: this.$t('centroCostos.common.warningGenerateFirst') || 'Genere primero el estado de resultados',
                    actions: [
                        { label: this.$t('buttons.close'), color: 'white', handler: () => { } }
                    ]
                })
                return;
            }

            let fechaI = new Date(this.fechaI);
            let fechaF = new Date(this.fechaF);
            const pdfBase64 = await EstadoResultadosPDF(this.itemsEstadoDeResultados, this.empresa, fechaI, fechaF);
            const fileName = 'Estado_de_Resultados_del_' + this.FormatoFechaSinHora(fechaI) + '_al_' + this.FormatoFechaSinHora(fechaF) + ".pdf";
            const link = document.createElement("a");
            link.href = pdfBase64;
            link.download = fileName;
            link.click();
        },

        async ExportarExcel() {
            if (this.itemsEstadoDeResultados.length == 0) {
                this.$q.notify({
                    type: 'warning',
                    message: this.$t('centroCostos.common.warningGenerateFirst') || 'Genere primero el estado de resultados',
                    actions: [
                        { label: this.$t('buttons.close'), color: 'white', handler: () => { } }
                    ]
                })
                return;
            }
            let fechaI = new Date(this.fechaI);
            let fechaF = new Date(this.fechaF);
            const data = [...this.itemsEstadoDeResultados];
            const columnsToInclude = ['signo', 'descripcion', 'importe'];
            const filteredData = data.map(item =>
                columnsToInclude.reduce((acc, column) => {
                    acc[column] = item[column];
                    return acc;
                }, {})
            );

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(filteredData);

            // Añadir descripciones
            const descriptions = [
                this.$t('reportes.estadoResultados.title').toUpperCase(),
                this.empresa.rfc + '| ' + this.empresa.nombre,
                'DEL ' + this.FormatoFechaSinHora(fechaI) + ' AL ' + this.FormatoFechaSinHora(fechaF),
                '',
            ];

            descriptions.forEach((desc, index) => {
                worksheet[XLSX.utils.encode_cell({ c: 0, r: index })] = { t: 's', v: desc };
            });

            // Añadir encabezados
            const columnHeaders = [
                this.$t('centroCostos.incomeStatement.sign'),
                this.$t('centroCostos.incomeStatement.description'),
                this.$t('centroCostos.incomeStatement.amount'),
            ];

            columnHeaders.forEach((header, index) => {
                worksheet[XLSX.utils.encode_cell({ c: index, r: descriptions.length })] = { t: 's', v: header };
            });

            // Combinar celdas A1 a H1 y centrar texto
            worksheet['!merges'] = worksheet['!merges'] || [];
            worksheet['!merges'].push({ s: { c: 0, r: 0 }, e: { c: 2, r: 0 } });
            worksheet['A1'].s = { alignment: { horizontal: 'center' } };

            // Combinar celdas A2 a H2 y centrar texto
            worksheet['!merges'].push({ s: { c: 0, r: 1 }, e: { c: 2, r: 1 } });
            worksheet['A2'].s = { alignment: { horizontal: 'center' } };

            // Combinar celdas A2 a H2 y centrar texto
            worksheet['!merges'].push({ s: { c: 0, r: 2 }, e: { c: 2, r: 2 } });
            worksheet['A3'].s = { alignment: { horizontal: 'center' } };

            // Añadir datos a partir del renglón después de los encabezados
            filteredData.forEach((row, rowIndex) => {
                columnsToInclude.forEach((column, columnIndex) => {
                    worksheet[XLSX.utils.encode_cell({ c: columnIndex, r: descriptions.length + rowIndex + 1 })] = { t: 's', v: row[column] };
                });
            });

            // Establecer formato decimal para las últimas seis columnas
            for (let row = 5; row < filteredData.length + 1; row++) {
                for (let col = 2; col <= 2; col++) {
                    const cellRef = XLSX.utils.encode_cell({ c: col, r: row });
                    if (worksheet[cellRef]) {
                        worksheet[cellRef].t = 'n'; // Tipo numérico para asegurar formato decimal
                        worksheet[cellRef].z = '#,##0.00'; // Formato decimal con dos decimales
                    }
                }
            }

            // Añadir la hoja al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Hoja1');

            // Guardar el libro como un archivo XLSX
            const nombreArchivo = 'ESTADO DE RESULTADOS ' + this.empresa.rfc + '_' + this.empresa.nombre + ' DEL ' + this.FormatoFechaSinHora(fechaI) + ' AL ' + this.FormatoFechaSinHora(fechaF)
            XLSX.writeFile(workbook, nombreArchivo + '.xlsx');
        },

        async ExportarExcelDos() {
            if (this.itemsEstadoDeResultados.length == 0) {
                this.$q.notify({
                    type: 'warning',
                    message: this.$t('centroCostos.common.warningGenerateFirst') || 'Genere primero el estado de resultados',
                    actions: [
                        { label: this.$t('buttons.close'), color: 'white', handler: () => { } }
                    ]
                })
                return;
            }
            let fechaI = new Date(this.fechaI);
            let fechaF = new Date(this.fechaF);
            let data = [...this.itemsEstadoDeResultados];
            for (let d in data) {
                if (d.signo === '=') {
                    d.importe = '';
                }
            }
            const columnsToInclude = ['signo', 'descripcion', 'importe'];
            const datos = data.map(item =>
                columnsToInclude.reduce((acc, column) => {
                    acc[column] = item[column];
                    return acc;
                }, {})
            );
            const arrayDeValores = datos.map(objeto => Object.values(objeto));
            const libroTrabajo = XLSX.utils.book_new();
            // Crear una hoja de cálculo
            const hojaCalculo = XLSX.utils.aoa_to_sheet([
                [this.$t('reportes.estadoResultados.title').toUpperCase()],
                [this.empresa.rfc + '| ' + this.empresa.nombre],
                ['DEL ' + this.FormatoFechaSinHora(fechaI) + ' AL ' + this.FormatoFechaSinHora(fechaF)],
                [],
                [
                    this.$t('centroCostos.incomeStatement.sign'),
                    this.$t('centroCostos.incomeStatement.description'),
                    this.$t('centroCostos.incomeStatement.amount'),
                ],
                ...arrayDeValores.map((registro, index) => [
                    registro[0],
                    registro[1],
                    { t: 'n', v: registro[2], z: '#,##0.00' },
                ]),
            ]);

            // Combinar celdas A1 a H1 y centrar texto
            hojaCalculo['!merges'] = [{ s: { r: 0, c: 0 }, e: { c: 2, r: 0 } }];
            hojaCalculo['!merges'].push({ s: { c: 0, r: 1 }, e: { c: 2, r: 1 } });
            hojaCalculo['!merges'].push({ s: { c: 0, r: 2 }, e: { c: 2, r: 2 } });

            // Añadir la hoja de cálculo al libro de trabajo
            XLSX.utils.book_append_sheet(libroTrabajo, hojaCalculo, 'Hoja1');

            // Guardar el libro como un archivo XLSX
            const nombreArchivo = 'ESTADO DE RESULTADOS ' + this.empresa.rfc + '_' + this.empresa.nombre + ' DEL ' + this.FormatoFechaSinHora(fechaI) + ' AL ' + this.FormatoFechaSinHora(fechaF)
            XLSX.writeFile(libroTrabajo, nombreArchivo + '.xlsx');
        },

        FormatoFechaSinHora(value) {
            const fecha = new Date(value);
            const fechaFormateada = format(fecha, 'dd-MMMM-yyyy', { locale: es });
            return fechaFormateada.toUpperCase();
        },

        async getCc(){
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: this.$t('centroCostos.list.wait') || 'Espere...', messageColor: 'white' })
            try {
                const response = await axios.get('CentrosCostos/GetCentroCostosAsync/erp_' + this.token.rfc)
                this.itemsCc = response.data;
                this.$q.loading.hide();
                console.log(response.data)
                this.dialogAsignaCc = true
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: this.$t('centroCostos.list.errorFetch') || 'Error al consultar.', color: 'red' })
            }
        },

        async VerDetalles(item){
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: this.$t('centroCostos.list.wait') || 'Espere...', messageColor: 'white' })
            this.dataDetPol = [];
            let listaPolizas = [];
            for(let i of item.detalles){
                for(let j of i.detalles){
                    for(let k of j.polizas){
                        const objPol = {
                            idPoliza : k,
                            numCuenta: j.numCuentaUnicoSat
                        };
                        listaPolizas.push(objPol)
                    }
                }
            }
            const model = {
                lista: listaPolizas,
            }
            const respuesta = await this.GetDetalle(model);
            this.dataDetPol = [...respuesta]
            this.dialogDetMov =  true;
            this.$q.loading.hide()
        },

        async GetDetalle(model){
            try{
                const response = await axios.post(`CentrosCostos/GetDetallePolizasAsync/erp_${this.token.rfc}`, model)
                return response.data;
            }catch(error){
                console.log(error);
                return null;
            }
        },

        async VerPolizas(item){
            console.log(item);
            this.dataPolizas = [];
            this.dataPolizas = item.polizas;
            this.dialogPolizas = true;
        },

        async VerPolizaPdf(item){
            console.log(item)
            const id = item._id;
            const poliza = await this.GetPolizaId(id)
            this.dialogPDF = true;
            this.$nextTick(() => {
                this.$store.state.vistaPreviaStore.color = "19775C"
                this.$store.state.vistaPreviaStore.tipo = "POLIZA"
                this.$refs.miComponenteHijo.VerPolizaPdf(poliza);
            }
            );
        },

        async VerFacturas(item){
            console.log(item);
            this.dataFacturas = [];
            this.dataFacturas = item.facturas;
            this.dialogFacturas = true;
        },

        async VerFacturaPdf(item){
            console.log(item)
            let tipo = item.tipoPoliza 
            if (tipo === 'Egreso') {
                this.$store.state.vistaPreviaStore.tipo = "R"
                this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "FACTURA"
                if (item.tipoComprobante === "N") {
                    this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "NOMINA"
                    this.$store.state.vistaPreviaStore.tipo = "E"
                } else if (item.tipoComprobante === "P") {
                    this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "PAGO"
                } else if (item.tipoComprobante === "E") {
                    this.$store.state.vistaPreviaStore.tipo = "E"
                }

            } else if (tipo === 'Ingreso') {
                this.$store.state.vistaPreviaStore.tipo = "E"
                this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "FACTURA"
                if (item.tipoComprobante === "N") {
                    this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "NOMINA"
                    this.$store.state.vistaPreviaStore.tipo = "R"
                } else if (item.tipoComprobante === "P") {
                    this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "PAGO"
                } else if (item.tipoComprobante === "E") {
                    this.$store.state.vistaPreviaStore.tipo = "R"
                }
            }
            try {
                this.dialogPDF = true;
                this.$nextTick(() => {
                    this.$store.state.vistaPreviaStore.folioFiscal = item.folioFiscal.toUpperCase();
                    this.$store.state.vistaPreviaStore.color = "19775C"
                    this.$store.state.vistaPreviaStore.rfc = this.token.rfc
                    this.$refs.miComponenteHijo.VerComprobante();
                });
            } catch (error) {
                console.log(error)
            }
        },

        async GetPolizaId(id) {
            try {
                let response = await axios.get("Polizas/GetPolizasIdAsync/erp_" + this.token.rfc + '/' + id);
                let poliza = response.data;
                return poliza
            } catch (error) {
                console.log(error)
            }
        },

        CloseDialogPdf() {
            this.dialogPDF = false;
        },

    }
}
</script>

<style>
.header-tabla thead th {
    border-bottom: 8px solid #662e91;
}
</style>